module.exports = __webpack_public_path__ + "static/seo-beyond-green-d5245758b32d3e9ddbf58e6eabd46c3c.png";